<app-paper>
  <div>
    <p [innerHTML]="'cookies.text' | translate"></p>
    <app-action-button variant="iconed" customIcon="close" (click)="onClose()"></app-action-button>
  </div>
</app-paper>
